import { render, staticRenderFns } from "./AddNewAlbum.vue?vue&type=template&id=24ed5476&scoped=true"
import script from "./AddNewAlbum.vue?vue&type=script&lang=js"
export * from "./AddNewAlbum.vue?vue&type=script&lang=js"
import style0 from "./AddNewAlbum.vue?vue&type=style&index=0&id=24ed5476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed5476",
  null
  
)

export default component.exports